<template>
  <section>
      <router-link style="color:inherit;"
                   :to="{name: conditionPageService(item.experience_id), params: {id : conditionWithParamId(item)}}">
        <div class="card pb-3 card-responsive-custom">
          <div class="row">
            <div class="col-4">
              <img :src="item.order.user && item.order.user.picture ? item.order.user.picture : '/static/img/unknown.png'"
                   alt="" class="rounded-circle img-profile mt-4 d-block mx-auto">
            </div>
            <div class="col-8">
              <div class="card-body pr-0 pl-0">
                <h5 class="card-title">{{ item.order.user.firstname }}</h5>
                <span class="ml-2">{{ item.create_date | timeSpan }}</span>
                <div>
                  <i class="fas fa-star -rating-star"></i>
                  <i class="fas fa-star -rating-star"></i>
                  <i class="fas fa-star -rating-star"></i>
                  <i class="fas fa-star -rating-star"></i>
                  <i class="fas fa-star -rating-star"></i>
                </div>
                <p class="card-text">{{ cutText(item.comment) }}</p>
              </div>
            </div>
          </div>
          <div class="row" style="margin: 0;">
            <div class="col-12">
              <div class="ref-professional float-right">

                <div class="image-box  float-right">
                  <img
                    :src="item.professional.full_picture ? item.professional.full_picture : '/static/img/unknown.png'"
                    style="width: 50px;"
                    alt="" class="rounded-circle">

                  <img src="/static/img/ic_badge_excellent.png"
                       class="badge-excellent-professional"
                       v-b-popover.hover.top="$i18n.t('message.professional.excellent_provider_detail', {name: item.professional.firstname})"
                       :title="$i18n.t('message.professional.excellent_provider_title')"
                       v-if="item.professional.is_excellent === 1">

                </div>
                <div style="display: inline-block;" class="pr-3">
                  <span>{{ item.professional.full_name | firstName }}</span><br>
                  <span v-if="item.order && item.order.service_id === 16">AC Cleaner</span>
                  <span v-else>Cleaner</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </router-link>
  </section>
</template>

<script>
import reviewHelpers from '../../../helpers/reviewHelpers'

export default {
  name: 'ReviewItems',
  props: ['item'],
  methods: {
    conditionPageService (experienceId) {
      return reviewHelpers.conditionPageService(experienceId)
    },
    conditionWithParamId (reviewObj) {
      return reviewHelpers.conditionWithParamId(reviewObj)
    },
    cutText (value) {
      return reviewHelpers.cutText(value)
    }
  }
}
</script>

<style scoped lang="scss">
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";

img.img-profile {
  width: 80px;
}

h5.card-title {
  font-weight: 500;
  display: inline-block;
}

div.ref-professional {
  text-align: right;

  div span:nth-child(1) {
    font-weight: 500;
  }

}

.no-focus:focus {
  outline: none !important;
}

.image-box {
  position: relative;

  img.badge-excellent-professional {
    width: 23px;
    position: absolute;
    right: 0;
    bottom: 0;
    margin-right: -2px;
    margin-bottom: -2px;
  }
}

.card-responsive-custom {

  overflow: auto;

  @include media-breakpoint-up(xs) {
    height: 290px;
  }

  @include media-breakpoint-up(sm) {
    height: 300px;
  }

  @include media-breakpoint-up(lg) {
    height: 285px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/review/components/ReviewItems.vue